/**
 * 连锁块项目管理
 */
 import axios from '../request';
 export default{
    

    /**
     * 连锁块项目管理
     */
    // 查询连锁块项目管理列表信息
    searchChainProjectList: params =>
        axios.post('/materials/chainProject/findList', params),
    // 添加或修改连锁块项目管理信息
    insertChainProjectOrUpdate: params =>
        axios.post('/materials/chainProject/addOrUpdate', params),
    // 连锁块项目管理信息详情
    detailsChainProject: params =>
        axios.post('/materials/chainProject/detail', params),
    // 删除连锁块项目管理信息
    deleteChainProject: params =>
        axios.post('/materials/chainProject/delete', params),
    //连锁块项目管理下拉
    getAllChainProject: params =>
        axios.get('/materials/', {params}),
    //导出数据
    exportChainProjectDatas:params=>
        axios({
            method: 'get',
            url: '/materials/chainProject/export',
            responseType: 'blob',
            params: params
        }),


 }